import type { ReactElement } from 'react'
import React, { useContext } from 'react'
import { Trigger as TooltipTrigger } from '@radix-ui/react-tooltip'
import { TooltipContext } from '../context'

export interface ITriggerProps {
  children: ReactElement
}

function Trigger(props: ITriggerProps) {
  const { children } = props

  const { enabled } = useContext(TooltipContext)
  if (!enabled) return children

  return (
    <TooltipTrigger asChild>
      <span>{children}</span>
    </TooltipTrigger>
  )
}

Trigger.displayName = 'Tooltip.Trigger'

export { Trigger }
